<template>
    <v-menu
        v-model                 = "menuOpen"
        max-width               = "400"
        min-width               = "400"
        :close-on-content-click = "false"
        content-class           = "recent-border"
        offset-y
    >
        <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <div
                        class  = "nav-dropdown"
                        v-bind = "attrs"
                        v-on   = "{ ...tooltip, ...menu }"
                        @click = "onMenu"
                    >
                        <v-icon
                            class = "nav-icon toolbar-button"
                            color = "primary"
                        >
                            {{ icon }}
                        </v-icon>
                    </div>
                </template>
                <span>{{ tooltip }}</span>
            </v-tooltip>
        </template>

        <v-container fluid style="padding: 0; " >
            <v-progress-linear
                v-if  = "loading"
                color ="primary"
                indeterminate
            ></v-progress-linear>

            <v-list style="padding-bottom: 1px; padding-top: 5px;">
                <v-hover
                    v-for  = "(recent, index) in recents"
                    :key   = "index" class="recent-panel"
                    v-slot:default="{ hover }"
                >
                    <v-list-item
                        @click = "onSelect(recent)"
                    >
                        <div class="w-100">
                            <div class="recent-title">
                                <slot name="title" v-bind:item="{ recent, hover }" />
                            </div>
                            <div class="recent-subtitle">
                                <slot name="subtitle" v-bind:item="recent" />
                            </div>
                        </div>
                    </v-list-item>
                </v-hover>
            </v-list>
        </v-container>
    </v-menu>
</template>

<script>

import Core from "@/modules/core/service/Core";

export default {
    name: "CAppRecent",

    props: {
        icon: {

        },

        tooltip: {

        },

        loader: {
            required: true,
            type    : Function
        }
    },

    data: () => ({
        menuOpen: false,
        loading : false,
        recents : []
    }),

    methods: {
        onMenu () {
            this.loading = true;
            this.loader ().then ((data) => {
                this.recents = data;
                this.loading = false;
            });
        },

        onSelect (item) {
            Core.fire.selected(this, item);
            this.menuOpen = false;
        },
    }
}
</script>

<style scoped>

.recent-title {
    font-size: 10pt;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
}

.recent-subtitle {
    font-size: 9pt;
    padding-top: 2px;
}

.recent-panel {
    cursor: pointer;
    border-style: solid;
    border-width: 1px;
    border-color: lightgray;
    border-radius: 5px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 5px 10px 10px;
}

.recent-border {
    border-radius: 5px;
}

</style>